<p-panel
  [showHeader]="false"
  styleClass="panel-shadow mt-3 no-padding-panel"
  [style]="{ 'max-width': '1650px' }"
  #panel
>
  <div class="ui-g job-details-container">
    <div class="ui-g-12">
      <div *ngIf="selectedTask" class="flex flex-wrap">
        <div *ngIf="tasks" class="style2023 listbox-wrapper">
          <p-listbox
            styleClass="no-border-listbox mobile-listbox-block extended-listbox-width"
            [ngModel]="selectedTask"
            (ngModelChange)="changeSelectedTask($event.id)"
            [options]="tasks"
            dataKey="id"
          >
            <ng-template let-task pTemplate="item">
              <div class="registration">
                {{ task.value.vehicle.regNumber }}
              </div>
              <div style="text-align: left; font-size: smaller">
                {{ task.value.vehicle.make }} {{ task.value.vehicle.model }}
              </div>
              <div style="text-align: left; font-size: smaller">
                {{ task.value.vehicle.kerbWeight }} kg. {{ task.value.vehicle.color }}
              </div>
            </ng-template>
          </p-listbox>
          <div
            *ngIf="tasks?.length > 1"
            class="task-sequence-indicator"
            [ngClass]="
              taskSequencingEnabled
                ? 'task-sequence-indicator-enabled'
                : 'task-sequence-indicator-disabled'
            "
          >
            <ng-container *ngIf="taskSequencingEnabled">
              <i
                class="fa fa-exclamation-triangle"
                aria-hidden="true"
                pTooltip="Tasks in this job must be completed in the specific sequence labeled."
              ></i>
              <div>Mandatory Task Sequence</div>
            </ng-container>

            <ng-container *ngIf="!taskSequencingEnabled">
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                pTooltip="Tasks in this job can be completed in any sequence."
              ></i>
              <div>Flexible Task Sequence</div>
            </ng-container>
          </div>
        </div>
        <div
          class="flex-grow-1"
          style="padding: 20px; box-shadow: -5px 0 5px -5px rgba(0, 0, 0, 0.3)"
        >
          <div class="flex grid-gap-15 flex-wrap justify-content-start">
            <div class="flex-grow-1" style="flex-basis: 200px; max-width: 750px">
              <div style="margin-right: 5px">
                <div style="margin-bottom: 15px">
                  <div class="flex justify-content-between align-items-center">
                    <div class="vehicle-reg">{{ selectedTask.vehicle.regNumber }}</div>
                    <span *ngIf="selectedTask">
                      <div
                        *ngFor="let category of selectedTask.checklistSubCategories"
                        style="margin-top: 7px; margin-right: 7px"
                      >
                        <checklist-category-item [subCategory]="category"></checklist-category-item>
                      </div>
                    </span>
                  </div>

                  <div class="vehicle-info">
                    {{ selectedTask.vehicle.make }} {{ selectedTask.vehicle.model }}
                  </div>
                  <div class="vehicle-info">
                    <span *ngFor="let field of secondaryVehicleInfo; let i = index">
                      {{ field }}<span *ngIf="i != secondaryVehicleInfo.length - 1"> &bull; </span>
                    </span>
                  </div>

                  <div class="flex align-items-baseline">
                    <div class="">
                      <span class="route-info-value">{{ routeInfo?.distanceMiles }} miles</span>
                      <span class="est">EST.</span>
                      <span class="est-div">/</span>
                    </div>

                    <div class="">
                      <span class="route-info-value">{{ routeInfo?.time }}</span>
                      <span class="est">EST.</span>
                    </div>

                    <div class="">
                      <span class="movement-type">{{ selectedTask.taskTypeName }}</span>
                    </div>
                  </div>
                </div>

                <route-job-screen-task-times
                  [routeRecommendationTask]="selectedTask"
                ></route-job-screen-task-times>
              </div>
            </div>

            <div
              class="flex-grow-1"
              style="max-width: 640px; flex-basis: 200px"
              *ngIf="interactiveMap"
            >
              <div>
                <div
                  [style.height.px]="mapHeight"
                  style="border-radius: 10px; overflow: hidden; margin-bottom: 7px; width: 100%"
                >
                  <map-control-v2
                    [routeId]="routeId"
                    [displayTaskLegends]="true"
                    [(selectedTaskId)]="selectedTaskId"
                    (taskClicked)="changeSelectedTask($event.taskId)"
                  ></map-control-v2>
                </div>
              </div>
            </div>
            <div *ngIf="!interactiveMap" (click)="interactiveMap = true" style="margin-bottom: 7px">
              <img
                [src]="staticMapSrc"
                *ngIf="staticMapSrc"
                style="border-radius: 10px"
                alt="Task Map"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-panel>
